var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    ref: "form",
    staticClass: "contact-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 medium-4 column required-input contact-form-first-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.firstName,
      expression: "formData.firstName"
    }],
    class: {
      'contact-form-validate-field': _vm.fieldsToValidate.firstName
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.translations.contactFormFirstName,
      "name": "firstName",
      "required": "",
      "maxlength": "64",
      "pattern": "^\\S\\D+\\S$",
      "readonly": !!_vm.formData.firstName && _vm.preFilled
    },
    domProps: {
      "value": _vm.formData.firstName
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "firstName", $event.target.value);
      }, function ($event) {
        return _vm.onInputUpdate($event);
      }],
      "focus": function focus($event) {
        return _vm.reportFieldValidity($event);
      },
      "blur": function blur($event) {
        _vm.setFieldToValidate($event.target.name), _vm.reportScreenSizeUpdate($event);
      }
    }
  }), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "small-12 medium-4 column end required-input contact-form-last-name"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.lastName,
      expression: "formData.lastName"
    }],
    class: {
      'contact-form-validate-field': _vm.fieldsToValidate.lastName
    },
    attrs: {
      "type": "text",
      "placeholder": _vm.translations.contactFormLastName,
      "name": "lastName",
      "required": "",
      "maxlength": "64",
      "pattern": "^\\S\\D+\\S$",
      "readonly": !!_vm.formData.lastName && _vm.preFilled
    },
    domProps: {
      "value": _vm.formData.lastName
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "lastName", $event.target.value);
      }, function ($event) {
        return _vm.onInputUpdate($event);
      }],
      "focus": function focus($event) {
        return _vm.reportFieldValidity($event);
      },
      "blur": function blur($event) {
        _vm.setFieldToValidate($event.target.name), _vm.reportScreenSizeUpdate($event);
      }
    }
  }), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])]), _c('div', {
    staticClass: "small-12 medium-4 column end required-input contact-form-email"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.formData.emailAddress,
      expression: "formData.emailAddress"
    }],
    class: {
      'contact-form-validate-field': _vm.fieldsToValidate.emailAddress
    },
    attrs: {
      "type": "email",
      "placeholder": _vm.translations.contactFormEmail,
      "name": "emailAddress",
      "required": "",
      "maxlength": "250",
      "readonly": !!_vm.formData.emailAddress && _vm.preFilled
    },
    domProps: {
      "value": _vm.formData.emailAddress
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formData, "emailAddress", $event.target.value);
      }, function ($event) {
        return _vm.onInputUpdate($event);
      }],
      "focus": function focus($event) {
        return _vm.reportFieldValidity($event);
      },
      "blur": function blur($event) {
        _vm.setFieldToValidate($event.target.name), _vm.reportScreenSizeUpdate($event);
      },
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.setFieldToValidate($event.target.name), _vm.reportFieldValidity($event);
      }
    }
  }), _c('span', {
    staticClass: "req"
  }, [_vm._v("*")])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "small-12 column contact-form-legal-text"
  }, [_c('strong', [_vm._v("\n        " + _vm._s(_vm.translations.contactFormDesc) + "\n        "), _c('a', {
    attrs: {
      "href": _vm.translations.contactFormLink,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.translations.contactFormLinkDesc))]), _vm._v("\n        " + _vm._s(_vm.translations.contactFormDesc2) + "\n      ")])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }